// 受保护路由守卫（四门户镜像契约 · 唯一路径 src/auth/RequireAuth.tsx）
// 核心已下沉 web/shared/components/RequireAuth（FE2-018 注入式）：本端注入
// @/api/client 会话判定与固定登录路径 '/login'，渲染行为与下沉前逐字节等价
//（无 accessToken → <Navigate to="/login" state={{from: location.pathname}} replace/>）。
import SharedRequireAuth from '@shared/components/RequireAuth';
import { loadSession } from '@/api/client';

export default function RequireAuth() {
  return (
    <SharedRequireAuth
      isAuthenticated={() => Boolean(loadSession()?.accessToken)}
      loginPath={() => '/login'}
    />
  );
}
